import appConstants from '../../../../../appConstants';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ isExtraRoute }) {
    return GridConfig.getDefaultConfiguration(isExtraRoute);
  }

  static getDefaultConfiguration(isExtraRoute) {
    return {
      title: appConstants.gridNames.dynamicRoutingRoutesSummary,
      defaultColDef: {
        lockPinned: true,
        sortable: false,
        filter: false,
        resizable: false,
        tooltipValueGetter: (params) => params.value // Show the cell value as tooltip
      },
      columns: [
        {
          headerName: 'Trailer Type',
          field: 'trailerType',
          width: isExtraRoute ? appConstants.columnWidth.W_120 : appConstants.columnWidth.W_80
        },
        {
          headerName: 'Routes',
          field: 'routes'
        },
        ...(isExtraRoute
          ? [
              {
                headerName: 'Comment',
                field: 'comment',
                width: appConstants.columnWidth.W_100
              }
            ]
          : [])
      ]
    };
  }
}
